module.exports = __webpack_public_path__ + "media/images/logo_full-b12036ea6cc5e8c8d20de334ebed6c5e.svg";